// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3DhJx","title":"AfterBackImages_title__uG-Nb","images":"AfterBackImages_images__1OQNQ"};